<template>
  <el-dialog title="退货邀请客户自助下单" :visible.sync="dialogVisible" :before-close="closeDialog" width="750px" :close-on-click-modal="false">
    <div class="" style="text-align:left;padding: 0px 0px 10px 0px;">
      <el-alert class="alert" title="" type="warning" show-icon :closable="false" style="width: 700px;">
        <div>1、客户扫码下单后，需您确认审核通过才会下单成功，也可设置自动审核</div>
        <div>2、更改退货收件地址后，会生成新二维码，原二维码会失效</div>
        <div>3、更改自动审核开关、用户下单配置和上门取件时间类型后，会生成新二维码，原二维码为原有设置，新二维码为新设置</div>
        <div>4、重置二维码后，历史生成的二维码会失效</div>
      </el-alert>
    </div>
    <el-form :model="form" label-width="10px" ref="ruleForm" class="y-p-r">
      <div class="big-title y-p-r">
        <span>自动通过审核</span>
      </div>
      <el-form-item label="" prop="autoAudit">
        <div class="y-f y-f-a y-mt-10">
          <el-switch v-model="form.autoAudit"></el-switch>
          <span class="y-ml-10">开启后，客户扫码下单后，系统自动审核通过并下单成功</span>
        </div>
      </el-form-item>
      <div class="big-title y-p-r">
        <span>退货收件地址</span>
      </div>
      <el-form-item label="" prop="addressId">
        <el-select
          :popper-append-to-body="false"
          popper-class="y-w-600"
          class="y-w-600 y-mt-15"
          v-model="form.addressId"
          filterable
          no-match-text=" "
          placeholder="请选择退货收件地址">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <span @click="showAddReciverInfo = true" class="systemColor y-ml-10 y-c-p">新增地址</span>
      </el-form-item>
      <div class="big-title y-p-r">
        <span>用户下单配置</span>
      </div>
      <el-form-item label="" prop="originalOrder">
        <div class="y-f y-f-a y-c-p y-mt-15">
          <el-checkbox v-model="form.originalOrder">用户下单时需填写原订单号</el-checkbox>
        </div>
      </el-form-item>
      <div class="big-title y-p-r">
        <span>上门取件时间</span>
      </div>
      <el-form-item label="" prop="dayFlag">
        <div class="y-f y-f-a y-c-p y-mt-15 y-fl-20" @click="form.dayFlag='today'">
          <img src="@/assets/images/icon/radio_check_new.png" class="radio-icon" v-if="form.dayFlag=='today'"/>
          <img src="@/assets/images/icon/radio_uncheck.png" class="radio-icon radio-icon-uncheck" v-else/>
          <div class="y-ml-10 y-f-shrink">当日取</div>
          <div class="y-ml-10">消费者下单审核通过后，业务员联系消费者预约取件时间</div>
        </div>
        <div class="y-f y-f-ab y-c-p y-mt-15 y-fl-20" @click="form.dayFlag='nextDay'">
          <div class="y-f y-f-a y-mr-20">
            <img src="@/assets/images/icon/radio_check_new.png" class="radio-icon" v-if="form.dayFlag=='nextDay'"/>
            <img src="@/assets/images/icon/radio_uncheck.png" class="radio-icon radio-icon-uncheck" v-else/>
            <div class="y-ml-10 y-f-shrink">定时取</div>
          </div>
          <div class="align-self">消费者下单审核通过后，为消费者选择的取件时间，若审核时已过预约取件开始时间，将自动调整为审核时间后近2小时</div>
        </div>        
      </el-form-item>
      <div class="big-title y-p-r y-f y-f-js" v-if="form.qrUrl">
        <span>自助下单二维码</span>
        <el-form-item label="" prop="qrUrl" label-width="184px" >
          <div class="y-mt-10">
            <div class="qr-container y-p-r">
              <img src="@/assets/images/icon/qrcode-border@2x.png" class="qrbg"/>
              <vue-qr
                class="custom-qr"
                v-if="isRefreshQrCode"
                :logo-src="logoSrc"
                :text="form.qrUrl"
                :size="120"
                :margin="8"
                :logoMargin="4"
              />
            </div>
            <div class="y-mt-20">
              <el-button type="primary" class="y-ml-10 y-w-100" @click="downloadQRCode()">下载二维码</el-button>
              <span class="y-ml-190 y-fc-systemcolor y-c-p" plain @click="updateInvitedCode">重置二维码</span>
            </div>
          </div>
        </el-form-item>

        <div class="download-box">
          <div class="qr-container-saveImg y-p-r" ref="imgRef" v-if="form.qrUrl">
            <img src="@/assets/images/icon/qrcode-border@2x.png" class="qrbg"/>
            <vue-qr
              class="custom-qr"
              v-if="isRefreshQrCode"
              :logo-src="logoSrc"
              :text="form.qrUrl"
              :size="240"
              :margin="8"
              :logoMargin="4"
            />
          </div>
        </div>
      </div>
    </el-form>
    <!-- 新增收货地址弹层 -->
    <reciverInfo  :value="showAddReciverInfo" :isNotShowCompany="true" @close="closeReciverDialog"></reciverInfo>
  </el-dialog>
</template>
<script>
import { getCustomerAddressApi } from '@/api/universal';
import reciverInfo from '@/views/baseInfo/printSetting/addressMaintenance/components/ConsigneeInfo.vue';
import { searchReturnPlaceOrderConfigApi, saveReturnPlaceOrderConfigApi, resetPlaceOrderQrApi } from '@/api/waybillPrint/returnPickupPrint'
import html2canvas from "html2canvas";
export default {
  name: "record-list",
  components: {
    reciverInfo,
    html2canvas
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      dialogVisible: this.isShow,
      form: {
        autoAudit: false,
        addressId: '',
        addressInfo: '',
        originalOrder: false,
        dayFlag: 'today',
        qrUrl: '',
      },
      options: [],
      showAddReciverInfo: false,
      isFirst: true,
      logoSrc: '',
      isRefreshQrCode: true,
      loadingDownload: false,
    };
  },
  computed: {
    customCondition() { 
      let str = `autoAudit:${this.form.autoAudit ? 1 : 0}|addressId:${this.form.addressId}|originalOrder:${this.form.originalOrder ? 1 : 0}|pickUpDateRule:${this.form.dayFlag == 'today'?0:2}`;
      return str;
    },
  },
  watch: {
    customCondition(newVal, oldVal) {
      console.log(`变更了配置 ----${newVal}`)
      let settingInfo = newVal.split('|');
      let addressInfo = settingInfo[1].split(':');
      // 无退货收件地址，不能生成二维码
      if (addressInfo.length < 2 || !addressInfo[1]) {
        return;
      }

      // 获取新地址的具体信息
      let newAddressInfo = '';
      if (isNaN(Number(addressInfo[1]))) {
        newAddressInfo = addressInfo[1];
      } else {
        let list = this.options.filter(t => { return t.value == addressInfo[1]; });
        if (list.length) {
          newAddressInfo = list[0].label;
        }
      }

      // 旧信息， 若是收件地址变更，则要废弃二维码
      let oldSettingInfoArr = oldVal.split('|');
      let oldAddressArr = oldSettingInfoArr.length && oldSettingInfoArr[1].split(':');

      // 获取旧地址的具体信息
      let oldAddressInfo = '';
      if (isNaN(Number(oldAddressArr[1]))) {
        oldAddressInfo = oldAddressArr[1];
      } else {
        let list = this.options.filter(t => { return t.value == oldAddressArr[1]; });
        if (list.length) {
          oldAddressInfo = list[0].label;
        }
      }
      
      let flag = 0; // 0: 不需要刷新， 1: 需要刷新--需要用具体的姓名、电话、手机、省市区、详细地址信息作对比，不一样的才能刷新二维码
      if (oldAddressArr.length && oldAddressInfo != newAddressInfo) {
        flag = 1;
      }

      // 有收件地址信息时，调保存配置接口
      this.saveSettingInfo(flag);
    },
  },
  methods: {
    initQrCode() {
      if (!this.form.qrUrl) {
        return
      }

      // 二维码刷新
      this.isRefreshQrCode = false;
      this.$nextTick(()=>{
        this.isRefreshQrCode = true;
      })
    },
    downloadQRCode(){
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      html2canvas(this.$refs.imgRef, {
        allowTaint: true, //允许污染
        taintTest: true, //在渲染前测试图片(没整明白有啥用)
        useCORS: true,
        backgroundColor: '#fff',
        width: 268,
        height: 268,
        x: -8,
        y:-8
      }).then(canvas => {
        let dataURL = canvas.toDataURL();// 获取二维码图片
        const link = document.createElement('a'); // 创建a元素来下载图片
        link.download = '退货下单二维码.png'; // 设置下载的文件名
        link.href = dataURL;
        link.click(); // 模拟点击以触发下载
        loadingMask.close();
      }).catch(() => {
        loadingMask.close();
      });
    },
    // 重新生成二维码和链接
    updateInvitedCode(){
      this.$confirm('重新生成后，原来的二维码将无法使用，请确认。', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        customClass: 'y-w-500',
        type: 'warning'
      }).then(() => {
        resetPlaceOrderQrApi({}).then(res => {
          if (res.status == 200) {

          } else {
            this.$message.error('重置二维码失败')
          }
        }).catch((err) => {
          this.$message.error(err.message || '网络异常，请稍后再试')
        }).finally(()=>{
          // 查询配置信息
          let loadingMask = this.$loading({
            lock: true,
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.3)'
          });
          this.getSettingInfo(loadingMask);
        });
      }).catch(() => {         
      });
    },
    // 获取收件人选择下拉列表
    getAddressList(){
      let params = {
        isSend: false,
        pageNo: 1,
        limit: 3000,
        name: '',
        telephone: '',
        address: '',
      };
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      getCustomerAddressApi(params).then((res) => {
        if (res.data && res.data.hasOwnProperty('total')) {
          let items = res.data.list || [];
          items.forEach((val) => {
            val.value = val.id
            val.label = `${val.name.trim()} ${val.mobile.trim() ? val.mobile.trim() : val.phone.trim()} ${val.provinceName}${val.cityName}${val.districtName}${val.address.trim()}`
          });
          this.options = items;
        } else {
          this.options = [];
          this.form.addressId = '';
        }
      }).catch(() => {
        this.options = [];
        this.form.addressId = '';
      }).finally(() => {
        // 查询配置信息
        this.getSettingInfo(loadingMask);
      });
    },
    closeReciverDialog() {
      this.getAddressList();
      this.showAddReciverInfo = false;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.form = {
        autoAudit: false,
        addressId: '',
        addressInfo: '',
        originalOrder: false,
        dayFlag: 'today',
        qrUrl: '',
      }
      this.$emit("closeDialog");
    },
    // 查询配置信息
    getSettingInfo(loadingMask) {
      searchReturnPlaceOrderConfigApi({}).then(res => {
        if (res.status == 200 && res.data) {
          let data = res.data;
          this.form.autoAudit = data.autoAudit == 1 ? true : false;
          this.form.addressId = data.addressId ? +data.addressId : '';
          this.form.addressInfo = data.addressInfo || '{}';
          this.form.originalOrder = data.originalOrder == 1 ? true : false;
          this.form.dayFlag = data.pickUpDateRule == 0 ? 'today' : 'nextDay';
          this.form.qrUrl = data.qrUrl;
          let addressInfo = JSON.parse(this.form.addressInfo);
          if (addressInfo.name) {
            let addressInfoLabel = `${addressInfo.name.trim()} ${addressInfo.mobile.trim() ? addressInfo.mobile.trim() : addressInfo.phone.trim()} ${addressInfo.provinceName}${addressInfo.cityName}${addressInfo.districtName}${addressInfo.address.trim()}`;
            let list = this.options.filter(t => { return t.label == addressInfoLabel; });
            // 接口返回的地址信息 在地址列表中不存在时，需将地址信息回显出来
            if (!list.length && addressInfo.name) {
              this.form.addressIdBak = this.form.addressId; // 先把原id备份，保存时要用
              this.form.addressId = addressInfoLabel; // 默认填充值
            }
          }
        } else {
          this.form = {
            autoAudit: false,
            addressId: '',
            addressInfo: '',
            originalOrder: false,
            dayFlag: 'today',
            qrUrl: '',
          }
          this.isFirst = false;
        }
      }).catch(err => {
        this.form = {
          autoAudit: false,
          addressId: '',
          addressInfo: '',
          originalOrder: false,
          dayFlag: 'today',
          qrUrl: '',
        }
        this.isFirst = false;
      }).finally(() => {
        loadingMask.close();
        this.initQrCode();
      });
    },
    // 保存配置信息
    saveSettingInfo(flag) {
      // 第一次初始化页面，不需要保存
      if (this.isFirst) {
        this.isFirst = false;
        return;
      }
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });

      
      let params = {
        autoAudit: this.form.autoAudit ? 1 : 0,
        addressId: this.form.addressId,
        originalOrder: this.form.originalOrder ? 1 : 0,
        pickUpDateRule: this.form.dayFlag == 'today' ? 0 : 2,
        qrUrl: '',
        needInvalid: flag || 0
      }
      if (isNaN(Number(this.form.addressId))) {
        // 当前收件地址在 地址薄中已不存在了
        params.addressInfo = this.form.addressInfo;
        params.addressId = this.form.addressIdBak;
      } else {
        let list = this.options.filter(t => { return t.value == this.form.addressId; });
        if (list.length) {
          let obj = {
            name: list[0].name,
            mobile: list[0].mobile,
            phone: list[0].phone,
            provinceName: list[0].provinceName,
            provinceCode: list[0].provinceCode,
            cityName: list[0].cityName,
            cityCode: list[0].cityCode,
            districtName: list[0].districtName,
            districtCode: list[0].districtCode,
            address: list[0].address
          };
          params.addressInfo = JSON.stringify(obj);
        }
      }
      saveReturnPlaceOrderConfigApi(params).then(res => {
        loadingMask.close();
        if (res.status == 200 && res.data) {
          this.$message.success('已重新生成二维码');
          this.$set(this.form, 'qrUrl', res.data);
          this.initQrCode();
        } else {
          this.$message.error(res.error || '保存失败！');
        }
      }).catch(()=>{
        loadingMask.close();
      })
    }
  },
  mounted() {
    this.logoSrc = require('@/assets/images/icon/Logo_YTO@2x.png');
    this.getAddressList();
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 10px 32px;
}
/deep/ .el-dialog__footer {
  text-align: center;
}
/deep/ .el-alert--warning.is-light {
  background: rgba(239,176,65,0.12);
  border-radius: 8px;
  border: 0;
  .el-alert__icon.el-icon-warning {
    align-self: baseline;
    margin-top: 5px;
    width: 24px;
    font-size: 24px;
  }
  .el-alert__description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }
}
.collapseBtn {
  width: 53px;
  height: 32px;
  cursor: pointer;
}
.collapseBtn.off{
  color: #EEEEEE;
}
.radio-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.big-title {
  padding-left: 10px;
}
.big-title::before {
  content: " ";
  position: absolute;
  left: 0px;
  top: 2px;
  width: 2px;
  height: 12px;
  background: #653EB3;
}
.y-ml-190 {
  margin-left: 200px;
}
.align-self {
  align-self: flex-start;
}
.logo-overlay {
  width: 50px;
  height: 50px;
}
.qr-container {
  width: 132px;
  height: 132px;
  background: #fff;
  .qrbg {
    position: absolute;
    top: 0;
    left: 0;
    width: 132px;
    height: 132px;
    z-index: 1;
  }
  .custom-qr {
    position: absolute;
    top: 6px;
    left: 6px;
    z-index: 1;
  }
}
.download-box {
  position: absolute;
  left: -50000px;
}
.qr-container-saveImg {
  width: 252px;
  height: 252px;
  background: #fff;
  .qrbg {
    position: absolute;
    top: 0;
    left: 0;
    width: 252px;
    height: 252px;
    z-index: 1;
  }
  .custom-qr {
    position: absolute;
    top: 6px;
    left: 6px;
    z-index: 1;
  }
}
</style>